import Image from "next/image";
import Link from "next/link";
import React, { useState, useMemo } from "react";
import { useCookies } from "react-cookie";
import { useQuery, QueryCache } from "react-query";
import { toast } from "react-toastify";
import { cameraImg } from "../../../public/assets/images";
import {
  getItemFromLocalStorage,
  parseJSON,
  setAuthHeader,
} from "../../../utils/local-storage";
import Router from "next/router";

import {
  getMyProducts,
  reSubmit,
  unPublishProduct,
} from "../../../api-client/my-product";
import {
  pen,
  stat,
  settings,
  search,
  closeModal,
} from "../../../public/assets/icons";
import {
  getProductCategory,
  publishProduct,
} from "../../../api-client/publish-product";
import Badge from "../../elements/badge";
import Button from "../../elements/button";
import Ellipsis from "../../elements/ellipsis";
import { capitalize } from "../../../utils/formatters";

import PaginatedTable from "../../elements/paginated-table.js";
import EditProductModal from "../../widgets/modals/edit-product";
import ProductInfo from "../../widgets/modals/product-info";
import PublishProductModal from "../../widgets/modals/publish-product/publish-modal";
import ViewStatsModal from "../../widgets/modals/view-stats";
import PageLoader from "../../widgets/page-loader";
import Table from "../../elements/table/index.js";
import Input from "../../elements/input/index.js";
import DatePickes from "../../widgets/filter/index.js";
import { Parser } from "json2csv";
// import Modal from "../setup-contest/modal.js";
import { usd } from "../../../public/assets/icons";
import { ErrorMessage, Formik } from "formik";
import DropDown from "../../elements/select";
import TextArea from "../../elements/textarea";
import { productPublishFormValidationSchema } from "../../../utils";
import AddInstruction from "../../widgets/modals/add-instruction";
import { truncate } from "../../../utils/truncate.js";
const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-[#205363] bg-opacity-[48%] flex items-center justify-center z-50 overflow-auto py-32">
       <div className=" lg:mt-[20%] mt-[144%] rounded-lg p-4 lg:w-[783px] w-[100%]   relative">
        <button
            onClick={onClose}
            className="text-red-500 absolute top-[4%] lg:top-[13%] right-0 ml-9"
          >
            <svg
              width="25"
              height="25"
              viewBox="0 0 40 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_7153_20336)">
                <path
                  d="M24.3167 13.332L20 17.6487L15.6834 13.332L13.3334 15.682L17.65 19.9987L13.3334 24.3154L15.6834 26.6654L20 22.3487L24.3167 26.6654L26.6667 24.3154L22.35 19.9987L26.6667 15.682L24.3167 13.332ZM20 3.33203C10.7834 3.33203 3.33337 10.782 3.33337 19.9987C3.33337 29.2154 10.7834 36.6654 20 36.6654C29.2167 36.6654 36.6667 29.2154 36.6667 19.9987C36.6667 10.782 29.2167 3.33203 20 3.33203ZM20 33.332C12.65 33.332 6.66671 27.3487 6.66671 19.9987C6.66671 12.6487 12.65 6.66536 20 6.66536C27.35 6.66536 33.3334 12.6487 33.3334 19.9987C33.3334 27.3487 27.35 33.332 20 33.332Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_7153_20336">
                  <rect width="40" height="40" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </button>
      <div className="bg-white mt-[24%] rounded-lg py-4 px-7 lg:w-[733px] w-full">
        
          {children}
        
      </div>
      </div>
    </div>
  );
};
const MyProductsTable = ({ initialProductData }) => {
  const [viewStats, setViewStats] = useState(false);
  const [editProduct, setEditProduct] = useState(false);
  const [openPublishProductModal, setOpenPublishProductModal] = useState(false);
  const [productInfoModal, setProductInfoModal] = useState(false);
  const [productToken, setProductToken] = useState("");
  const [unPublishLoading, setUnpublishLoading] = useState(false);

  // const [cookie, setCookies] = useCookies();
  const [clickCount, setClickCount] = useState(0);
  const queryCache = new QueryCache();
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [activeDropDown, setActiveDropDown] = useState(false);
  const [buttonText, setButtonText] = useState("Download CSV");
  const [modalOpen, setModalOpen] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showForm, setShowForm] = useState(false); // Add this state to handle step

  const handleContinue = () => {
    setShowForm(true); // Proceed to the form input
  };

  const handleClick = () => {
    setButtonText("Coming Soon");
  };

  // Fetch product categories
  const { data: productCategories } = useQuery(
    "product-categories",
    getProductCategory
  );

  // Product Type Data
  const productTypeData = [
    { label: "Digital", value: "digital" },
    { label: "Physical", value: "physical" },
    { label: "Service", value: "service" },
  ];

  // Approve By
  const approveAffiliateBy = [
    { label: "Automatic", value: "automatic" },
    { label: "Manual", value: "manual" },
  ];

  // category dropdown
  const categoryData = useMemo(() => {
    return productCategories?.data?.data?.map((category, index) => ({
      label: category.name,
      value: category.name,
    }));
  }, [productCategories]);

  // Currency Dropdown
  const currencyData = [{ img: usd, label: "USD" }];

  // Initialise States
  const [preview, setPreview] = useState(null);
  const [cookies, setCookies] = useCookies();
  const [approvalMethod, setApprovalMethod] = useState("");
  const [productType, setProductType] = useState("");
  const [addInstruction, setAddInstruction] = useState(true);
  // const [productCategory, setProductType] = useState('');
  const [currencySelected, setCurrencySelected] = useState({
    url: "",
    label: "",
  });
  const [productCategory, setProductCategory] = useState("");

  const [loading, setLoading] = useState(false);

  const handlePublishProduct = async (data) => {
    const {
      price,
      productName,
      image,
      productDescription,
      marketingResUrl,
      webinarUrl,
      salesPageUrl,
      thankYouPageUrl,
      commission,
    } = data;

    let formData = new FormData();

    formData.set("productType", capitalize(productType));
    formData.set("price", price);
    formData.set("name", productName);
    formData.set("category", productCategory);
    formData.set("description", productDescription);
    formData.set("commission", commission);
    formData.append("image", image);
    formData.set("approvalType", approvalMethod);
    formData.set("salesPageUrl", salesPageUrl),
      formData.set("thankYouPageUrl", thankYouPageUrl),
      formData.set("marketingResUrl", marketingResUrl);
      formData.set("webinarUrl", webinarUrl);
    formData.set("vendorId", cookies.vendorId);

    setLoading(true);
    setAuthHeader(parseJSON(getItemFromLocalStorage("authToken")));

    if (productType === "") {
      setLoading(false);
      return toast.error("Please select product type");
    }
    if (approvalMethod === "") {
      setLoading(false);
      return toast.error("Please select approval method");
    }
    if (approvalMethod === "") {
      setLoading(false);
      return toast.error("Please select approval method");
    }
    setAuthHeader(cookies.authToken);
    try {
      const res = await publishProduct(formData);
      toast.success("Success");
      setCookies("pixel", res.data.data.product, {
        path: "/",
      });
      setLoading(false);
      Router.push(
        `/dashboard/publish-products/generate-button/${res.data.data.product.productToken}`
      );
    } catch (error) {
      setLoading(false);

      // Check for error response and display appropriate message
      const errorMessage =
        error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : "An error occurred";
      toast.error(errorMessage);
    }
  };

  const [selectedDateRange, setSelectedDateRange] = useState({
    start: null,
    end: null,
  });
  const [filterStatus, setFilterStatus] = useState("all"); // State for filtering by payment status

  // const {
  //   data: product,
  //   isLoadingPPP,
  //   isError,
  // } = useQuery('my-products', getMyProducts, {
  //   initialData: initialProductData,
  //   staleTime: 1000,
  // });

  const {
    data: products,
    isLoading,
    refetch,
  } = useQuery(
    ["my-products", pageNumber.pageSize, selectedDateRange],
    () => {
      const data = {
        authToken: cookies?.authToken,
        pageNumber,
        pageSize,
        searchText: searchText || "",
        startDate: selectedDateRange.start,
        endDate: selectedDateRange.end,
        dateRange: selectedDateRange,
        // status: filterStatus !== "all" ? filterStatus : undefined,
      };
      return getMyProducts(data);
    },
    {
      initialData: initialProductData,
      staleTime: 1000,
    }
  );
  const handleDateRangeChange = (dateRange) => {
    setSelectedDateRange(dateRange);
    setPageNumber(1);
    refetch();
  };

  const clearInput = () => {
    setSearchText("");
    setTimeout(() => {
      refetch();
    }, 1000);
  };
  const handleFilterByStatus = (status) => {
    setFilterStatus(status);
    setPageNumber(1); // Reset page number when changing filter
    refetch(); // Explicitly refetch when status changes
  };
  // Initialize Router

  const dataTable = React.useMemo(() => {
    return products?.data?.data?.getProduct;
  }, [products]);

  // Unpublish Product
  const handleUnPublish = React.useCallback(
    async (token) => {
      setUnpublishLoading(true);
      const data = {
        productToken: Number(token),
      };
      try {
        const res = await unPublishProduct(data);
        toast.success("Product Unpublished Successfully");
        setUnpublishLoading(false);
        refetch();
        queryCache.clear("my-products");
      } catch (error) {
        setUnpublishLoading(false);
      }
    },
    [queryCache]
  );

  const handleResubmit = React.useCallback(async (data) => {
    setUnpublishLoading(true);
    const formData = {
      productToken: Number(data),
    };
    try {
      const res = await reSubmit(formData);
      toast.success(res.data.message);
      setUnpublishLoading(false);
    } catch (error) {
      toast.error("Something went wrong");
      setUnpublishLoading(false);
    }
  }, []);

  const column = React.useMemo(() => {
    return [
      // {
      //   Header: "Product Name",
      //   accessor: "name",
      // },
      {
        Header: "Product Name",
        accessor: "name",
        Cell: ({ row }) => {
          const { name } = row.original;
          return (
            <div className="  w-fit">
              <h4 className="font-bolder text-[1rem] truncate">
                {truncate(name, 40)}{" "}
                {/* Adjust the maxLength as needed */}
              </h4>
            </div>
          );
        },
      },
      {
        Header: "Category",
        accessor: "category",
        Cell: ({ row }) => {
          const { category } = row.original;
          return (
            <div className="pr-4  w-auto">
              <h4 className="font-bolder text-[1rem] truncate">
                {truncate(category, 40)}{" "}
                {/* Adjust the maxLength as needed */}
              </h4>
            </div>
          );
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ row }) => {
          const renderStatusBadge = (data) => {
            switch (data) {
              case "Submitted":
                return "info";
              case "Integrated":
                return "info";
              case "Unpublished":
                return "warn";
              case "Approved":
                return "default";
              case "Published":
                return "success";
              case "Rejected":
                return "danger";
              default:
                return "default";
            }
          };
          return (
            <div className="">
            <Badge
              text={row.values.status}
              status={renderStatusBadge(row.values.status)}
            />
            </div>
          );
        },
      },
      {
        Header: "Price",
        accessor: "price",
        Cell: ({ row }) => {
          return `$${row.original.price.toLocaleString()}`;
        },
      },
      {
        Header: "Commission",
        accessor: "commission",
        Cell: ({ row }) => {
          return `${row.original.commission}%`;
        },
      },
      {
        Header: "",
        accessor: "active",
        Cell: ({ row }) => {
          const renderStatus = (data) => {
            switch (data) {
              case "Approved":
              case "Submitted":
                return "Publish";
              case "Published":
                return "Unpublish";
              case "Rejected":
                return "Appeal";
              default:
                return "Publish";
            }
          };
          return (
            <div className="flex items-center justify-between">
            
              <div className="flex items-center">
                {row.values.status === "Rejected" ? (
                  <Link href="#">
                    <a
                      href="mailto:admin@stakecut.com"
                      rel="noreferrer"
                      target="_blank"
                    >
                      <Button
                        className={`${
                          row.values.status === "Approved" ||
                          row.values.status === "Published" ||
                          row.values.status === "Unpublished"
                            ? "btn-primary"
                            : row.values.status === "Rejected"
                            ? "bg-secondary text-white"
                            : "bg-neutral-light-40 text-white"
                        } px-4 py-5 w-48`}
                        label={renderStatus(row.values.status)}
                        loading={unPublishLoading}
                      />
                    </a>
                  </Link>
                ) : (
                  <Button
                    className={`${
                      row.values.status === "Approved" ||
                      row.values.status === "Published" ||
                      row.values.status === "Unpublished"
                        ? "btn-primary"
                        : row.values.status === "Rejected"
                        ? "bg-secondary text-white"
                        : "bg-neutral-light-40 text-white"
                    } px-4 py-5 w-48 `}
                    label={renderStatus(row.values.status)}
                    loading={unPublishLoading}
                    onClick={() => {
                      if (row.values.status === "Approved") {
                        setOpenPublishProductModal(true);
                        setProductToken(row.original.productToken);
                      } else if (row.values.status === "Published") {
                        setUnpublishLoading(true);
                        setTimeout(
                          () => handleUnPublish(row.original.productToken),
                          2000
                        );
                      } else if (row.values.status === "Unpublished") {
                        handleResubmit(row.original.productToken);
                      } else {
                        console.log("Rejected");
                      }
                    }}
                  />
                )}

                {/* <PopperMenu context={row} /> */}
              </div>
            </div>
          );
        },
      },
      {
        Header: "Action",
        accessor: "Action",
        Cell: ({ row }) => {
            return <PopperMenu context={row} />;
        },
    }
    
    ];
  }, []);
  const handleDownloadCSV = () => {
    const csvData = dataTable.map((row) => ({
      ProductName: `${row.name}`,

      Amount: row.price,
      Commission: `${row.commission}%`,
      // Date: getDateTime(row.createdAt),
      AmountEarned: row.commission,
      Status: row.paymentStatus,
    }));

    const fields = [
      "ProductName",

      "Amount",
      "Commission",
      "Date",
      "AmountEarned",
      "Status",
    ];
    const json2csvParser = new Parser({ fields });
    const csv = json2csvParser.parse(csvData);

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", "Recent_Sales.csv");
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  // Popper Menu
  const PopperMenu = ({ context }) => {
    const [isOpen, setIsOpen] = useState(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const data = [
      {
        item: "View Product Info",
        url: ``,
        icon: stat,
      },
      {
        item: "View Stats",
        url: `/my-product?productToken=${context.original.productToken}`,
        icon: stat,
      },
      { item: "Edit Product Details", url: `#`, icon: pen },
      {
        item: "Settings",
        url: `/dashboard/publish-products/generate-button/${context.original.productToken}`,
        icon: settings,
      },
    ];

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const data2 = [
      {
        item: "View Product Info",
        url: ``,
        icon: stat,
      },
      {
        item: "View Stats",
        url: `/my-product?productToken=${context.original.productToken}`,
        icon: stat,
      },

      {
        item: "Settings",
        url: `/dashboard/publish-products/generate-button/${context.original.productToken}`,
        icon: settings,
      },
    ];

    const dataList = useMemo(
      () => (context.values.status === "Approved" ? data : data2),
      [context.values.status, data, data2]
    );

    return (
      <div
        className="flex items-center justify-start"
        // onMouseLeave={() => setIsOpen(false)}
      >
        {isOpen && (
          <div>
            <RenderPopUp
              data={data}
              productToken={context.original.productToken}
            />
            <div
              className="h-full w-full  fixed z-40 top-0 left-0"
              onClick={() => setIsOpen(false)}
            ></div>
          </div>
        )}
        <div className="flex items-center ">
          <button onClick={() => setIsOpen(true)}>
            <Ellipsis />
          </button>
        </div>
      </div>
    );
  };

  // Render Popup menu
  const RenderPopUp = ({ data, productToken }) => {
    return (
      <ul className="p-2 h-auto  shadow ml-[-120px] absolute bg-white  rounded-tl-[24px] rounded-br-[24px] z-50">
        {data.length > 0 &&
          data.map((list, idx) => {
            return (
              <li
                className={`text-xs py-3 text-[#282828] hover:text-white hover:bg-primary-p300 rounded-[10px] px-5 transition-all duration-200 ease-in-out `}
                onClick={() => {
                  if (idx === 1) {
                    setViewStats(true);
                    setEditProduct(false);
                    setProductInfoModal(false);
                  } else if (idx === 2) {
                    setViewStats(false);
                    setEditProduct(true);
                    setProductInfoModal(false);
                  } else if (idx === 0) {
                    setProductInfoModal(true);
                    setViewStats(false);
                    setEditProduct(false);
                  } else {
                    window.location.href = list.url;
                  }
                  setProductToken(productToken);
                  setClickCount((prev) => prev++);
                }}
                key={idx}
              >
                <Link href={data.url || "#"} passHref>
                  <div className="flex items-center">
                    <div className="flex items-center justify-center">
                      <Image src={list.icon} alt="icon" />
                    </div>
                    <div className="ml-3">{list.item}</div>
                  </div>
                </Link>
              </li>
            );
          })}
      </ul>
    );
  };
  return (
    <section>
      {isLoading ? (
        <div className="flex items-center justify-center ">
          <PageLoader
            loadingText="Loading Products, Please Wait... 😇 "
            className="h-96 w-full"
          />
        </div>
      ) : (
        <div>
          <div>
            <div className="flex lg:flex-row flex-col pb-10 justify-between z-[1000] lg:items-center">
              <div className="text-[14px] text-[#828282] lg:ml-0 ml-5">
                My Products <span className="text-[#58D96B]">()</span>
              </div>

              <div className="flex lg:flex-row flex-col items-center justify-center mr-0 lg:mr-3">
                <div className="flex">
                  {/* <DateFilterComponent onDateRangeChange={handleDateRangeChange}   activeDropDown={activeDropDown}
            setDropDown={setActiveDropDown} /> */}
                  <DatePickes
                    onDateRangeChange={handleDateRangeChange}
                    activeDropDown={activeDropDown}
                    setDropDown={setActiveDropDown}
                  />
                  <form
            className=" z-1 bg-white"
            onSubmit={(e) => {
              e.preventDefault();
              refetch();
            }}
          >
            <Input
              type="text"
              className="border-[1px] bg-white  rounded-[8px] border-[#B3BAC5]"
              style={{ backgroundColor: "white" }}
              rightIcon={
                <Image
                  onClick={refetch}
                  className="cursor-pointer"
                  src={search}
                  alt="search"
                />
              }
              onChange={(e) => setSearchText(e.target.value)}
              value={searchText}
              placeholder="Search available items..."
              icon={
                <Image
                  onClick={() => clearInput()}
                  className="cursor-pointer"
                  src={closeModal}
                  alt="cancel"
                />
              }
            />
            {/* <FilterComponent data={data} onFilter={handleFilter} className="lg:w-1/2 w-full" /> */}

            {/* <FilterComponent data={data} onFilter={handleFilter} /> */}
          </form>
                </div>
                <div className="flex justify-end   lg:w-auto w-full">
                  {/* <button
                  onClick={handleDownloadCSV}
                  className="btn btn-primary w-[100%]  lg:w-[173px] h-[48px] py-2 mx-2 rounded-[10px]"
                >
                  Download CSV
                </button> */}

                  {/* <button
      className="btn btn-primary w-[100%] lg:w-[173px] h-[48px] py-2 mx-2 rounded-[10px]"
      onClick={handleClick}
    >
      {buttonText}
    </button> */}

                  <Button
                    className="btn btn-primary w-[100%] lg:w-[173px] h-[48px] py-2 mx-2 rounded-[10px]"
                    label="Publish Product"
                    onClick={() => setIsModalOpen(true)}
                  />
                </div>
              </div>
            </div>

            {/* <div className="flex justify-between items-center  my-16">
        <div className="text-[14px] text-[#828282]">
          Contests <span className="text-[#58D96B]"></span>
        </div>
        <div className="flex items-center  ">
          <Button
            className="px-5 py-3 btn-primary w-[174px] h-[42px]"
            label="Publish Product"
            onClick={() => setIsModalOpen(true)}
          />
        </div>
      </div> */}
            <hr />
            {/* <div className="flex  mt-16">
            <button
              onClick={() => handleFilterByStatus("all")}
              className={` mx-3 p-3 rounded-[10px] btn ${
                filterStatus === "all" ? "btn-primary" : "btn-secondary"
              }`}
            >
              All
            </button>
            <button
              onClick={() => handleFilterByStatus("success")}
              className={`  mx-3 p-3 rounded-[10px] btn ${
                filterStatus === "success" ? "btn-primary" : "btn-secondary"
              }`}
            >
              Success
            </button>
            <button
              onClick={() => handleFilterByStatus("pending")}
              className={` mx-3 p-3 rounded-[10px] btn ${
                filterStatus === "pending" ? "btn-primary" : "btn-secondary"
              }`}
            >
              Pending
            </button>
          </div> */}
          </div>
          <>
            {openPublishProductModal && (
              <PublishProductModal
                setOpenPublishProductModal={setOpenPublishProductModal}
                productToken={productToken}
              />
            )}
            {viewStats && (
              <ViewStatsModal
                setViewStats={setViewStats}
                productToken={productToken}
              />
            )}
            {editProduct && (
              <EditProductModal
                setEditProduct={setEditProduct}
                productToken={productToken}
              />
            )}
            {productInfoModal && (
              <ProductInfo
                setProductInfoModal={setProductInfoModal}
                productToken={productToken}
              />
            )}
            <div>
              {dataTable.length === 0 ? (
                <div className="text-center flex items-center justify-center flex-col py-10">
                  <p>
                    <svg
                      width="60"
                      height="60"
                      viewBox="0 0 80 80"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g opacity="0.5">
                        <rect width="80" height="80" rx="40" fill="#EBFBFF" />
                        <g clipPath="url(#clip0_7374_18002)">
                          <path
                            d="M26.6666 29.9987H23.3333V53.332C23.3333 55.1654 24.8333 56.6654 26.6666 56.6654H49.9999V53.332H26.6666V29.9987ZM53.3333 23.332H33.3333C31.4999 23.332 29.9999 24.832 29.9999 26.6654V46.6654C29.9999 48.4987 31.4999 49.9987 33.3333 49.9987H53.3333C55.1666 49.9987 56.6666 48.4987 56.6666 46.6654V26.6654C56.6666 24.832 55.1666 23.332 53.3333 23.332ZM53.3333 46.6654H33.3333V26.6654H53.3333V46.6654ZM41.6666 43.332H44.9999V38.332H49.9999V34.9987H44.9999V29.9987H41.6666V34.9987H36.6666V38.332H41.6666V43.332Z"
                            fill="#205363"
                          />
                        </g>
                      </g>
                      <defs>
                        <clipPath id="clip0_7374_18002">
                          <rect
                            width="40"
                            height="40"
                            fill="white"
                            transform="translate(20 20)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </p>
                  <p className="my-5">
                    You have not set up any contest for your product(s) yet
                  </p>
                  <div className="flex items-center mb-6 my-4">
                    <Button
                      className="px-5 py-3 btn-primary w-[184px] h-[42px]"
                      label="Publish Product"
                      onClick={() => setIsModalOpen(true)}
                    />
                  </div>
                </div>
              ) : (
                <Table
                  columns={column}
                  data={dataTable}
                  productToken={productToken}
                  pageSize={pageSize}
                  currentPage={pageNumber}
                  setPageNumber={setPageNumber}
                  setPageSize={setPageSize}
                  refetch={refetch}
                  searchText={searchText}
                  setSearchText={setSearchText}
                  totalPage
                />
              )}
            </div>
          </>
        </div>
      )}
      
        <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
          {showForm ? (
            <section className="w-full mx-auto ">
              <Formik
                initialValues={{
                  price: "",
                  productName: "",
                  image: "",
                  productDescription: "",
                  commission: "",
                  marketingResUrl: "",
                  webinarUrl:"",
                  salesPageUrl: "",
                  thankYouPageUrl: "",
                }}
                validationSchema={productPublishFormValidationSchema}
                onSubmit={async (data) => {
                  handlePublishProduct(data);
                }}
              >
                {({
                  values,
                  handleChange,
                  handleSubmit,
                  errors,
                  touched,
                  setFieldValue,
                }) => (
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      handleSubmit();
                    }}
                    encType="multipart/form-data"
                  >
                   
                      <div className="lg:col-span-2 col-span-3 order-2 lg:order-1 lg:px-3 px-1 border-3 border-purple-900">
                        <div className="col-span-3 lg:col-span-1 order-1 lg:order-2  lg:items-start mt-3 ">
                          <div className="flex ">
                            <div
                              className={`h-44 rounded-full relative w-44 bg-gradient-to-t from-slate-700 to-slate-400 overflow-hidden ${
                                errors.image && touched.image
                                  ? "border-2 border-red-400"
                                  : null
                              }`}
                            >
                              <Image
                                src={
                                  preview
                                    ? URL.createObjectURL(preview)
                                    : cameraImg
                                }
                                layout="fill"
                                alt="upload"
                                objectFit="cover"
                              />
                              <div className="absolute">
                                <input
                                  type="file"
                                  className="h-44 w-44 opacity-0"
                                  name="image"
                                  accept="image/*"
                                  onChange={(e) => {
                                    setPreview(e.target.files[0]);
                                    setFieldValue("image", e.target.files[0]);
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="flex items-center justify-center">
                            <ErrorMessage name="image">
                              {(msg) => (
                                <p className="error-text text-center text-xs">
                                  {msg}
                                </p>
                              )}
                            </ErrorMessage>
                          </div>
                        </div>
                        <div className="mt-3">
                          <label htmlFor="" className="text-base mt-3 mb-2">
                            Product Name
                          </label>
                          <Input
                            placeholder="Enter Product Name"
                            onChange={handleChange}
                            type="text"
                            name="productName"
                            value={values.productName}
                            error={errors.productName && touched.productName}
                          />
                          <ErrorMessage name="productName">
                            {(msg) => (
                              <p className="error-text text-xs">{msg}</p>
                            )}
                          </ErrorMessage>
                        </div>
                        <div className="mt-4">
                          <TextArea
                            label="Description"
                            placeholder="Enter Product Description"
                            onChange={handleChange}
                            textAreaName="productDescription"
                            value={values.productDescription}
                            error={
                              errors.productDescription &&
                              touched.productDescription
                            }
                          />
                          <ErrorMessage name="productDescription">
                            {(msg) => (
                              <p className="error-text text-xs">{msg}</p>
                            )}
                          </ErrorMessage>
                        </div>
                        <div className="grid grid-cols-2 gap-3 lg:gap-6 mt-6">
                          <div>
                            <label
                              htmlFor=""
                              className="text-sm lg:text-base  mb-2"
                            >
                              Product Category
                            </label>
                            <DropDown
                              options={categoryData}
                              value={productCategory}
                              selected={productCategory}
                              setSelected={setProductCategory}
                              setValue={setProductCategory}
                            />
                            <ErrorMessage name="productCategory">
                              {(msg) => (
                                <p className="error-text text-xs">{msg}</p>
                              )}
                            </ErrorMessage>
                          </div>
                          <div>
                            <label
                              htmlFor=""
                              className="text-sm lg:text-base mb-2"
                            >
                              Product Type
                            </label>
                            <DropDown
                              options={productTypeData}
                              value={productType}
                              setValue={setProductType}
                              selected={productType}
                              setSelected={setProductType}
                            />
                          </div>
                        </div>
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 lg:gap-6 mt-6">
                          <div>
                            <label
                              htmlFor=""
                              className="text-sm lg:text-base mb-2"
                            >
                              Currency
                            </label>
                            <Input
                              placeholder="USD"
                              onChange={handleChange}
                              type="text"
                              name="Currency"
                              value="USD"
                              disabled={true}
                            />
                          </div>
                          <div className="col-span-2 lg:col-span-1">
                            <label
                              htmlFor=""
                              className="text-sm lg:text-base mb-2"
                            >
                              Product Price($)-$1 = N1,200
                            </label>
                            <Input
                              placeholder="Enter Product Price"
                              onChange={handleChange}
                              type="number"
                              name="price"
                              value={values.price}
                              error={errors.price && touched.price}
                            />
                            <ErrorMessage name="price">
                              {(msg) => (
                                <p className="error-text text-xs">{msg}</p>
                              )}
                            </ErrorMessage>
                          </div>
                        </div>
                        <div className="grid grid-cols-2  gap-3 lg:gap-6  mt-6">
                          <div className="col-span-2 lg:col-span-1">
                            <label
                              htmlFor=""
                              className="text-sm lg:text-base mb-2"
                            >
                              Commission Percentage
                            </label>
                            <Input
                              type="number"
                              placeholder="Enter Commission Percentage"
                              onChange={handleChange}
                              name="commission"
                              value={values.commission}
                              error={errors.commission && touched.commission}
                            />
                          </div>
                          <div className="col-span-2 lg:col-span-1">
                            <label
                              htmlFor=""
                              className="text-sm lg:text-base mb-2"
                            >
                              How to approve Affiliates
                            </label>
                            <DropDown
                              options={approveAffiliateBy}
                              selected={approvalMethod}
                              setSelected={setApprovalMethod}
                              value={approvalMethod}
                              setValue={setApprovalMethod}
                            />
                          </div>
                        </div>
                        <div className="mt-6">
                          <label
                            htmlFor=""
                            className="text-sm lg:text-base mb-2"
                          >
                            URL to Product Sales Page
                          </label>
                          <Input
                            placeholder="Enter URL for Product Sales Page"
                            onChange={handleChange}
                            type="text"
                            name="salesPageUrl"
                            value={values.salesPageUrl}
                            error={errors.salesPageUrl && touched.salesPageUrl}
                          />
                          <ErrorMessage name="salesPageUrl">
                            {(msg) => (
                              <p className="error-text text-xs">{msg}</p>
                            )}
                          </ErrorMessage>
                        </div>
                        <div className="mt-6">
                          <label
                            htmlFor=""
                            className="text-sm lg:text-base mb-2"
                          >
                            URL to Product Download or Thank you page
                          </label>
                          <Input
                            placeholder="Enter URL for Product Download or Thank you page"
                            onChange={handleChange}
                            type="text"
                            name="thankYouPageUrl"
                            value={values.thankYouPageUrl}
                            error={
                              errors.thankYouPageUrl && touched.thankYouPageUrl
                            }
                          />
                          <ErrorMessage name="thankYouPageUrl">
                            {(msg) => (
                              <p className="error-text text-xs">{msg}</p>
                            )}
                          </ErrorMessage>
                        </div>
                        <div className="mt-6 mb-9">
                          <label
                            htmlFor=""
                            className="text-sm lg:text-base mb-2"
                          >
                           Webinar URL
                          </label>
                          <Input
                            placeholder="Enter the URL of your marketing resources"
                            onChange={handleChange}
                            type="text"
                            name="webinarUrl"
                            value={values.webinarUrl}
                            error={
                              errors.webinarUrl && touched.webinarUrl
                            }
                          />
                          <ErrorMessage name="webinarUrl">
                            {(msg) => (
                              <p className="error-text text-xs">{msg}</p>
                            )}
                          </ErrorMessage>
                        </div>
                        <div className="mt-6 mb-9">
                          <label
                            htmlFor=""
                            className="text-sm lg:text-base mb-2"
                          >
                            URL to JV Page or Marketing Resources
                          </label>
                          <Input
                            placeholder="Enter the URL of your marketing resources"
                            onChange={handleChange}
                            type="text"
                            name="marketingResUrl"
                            value={values.marketingResUrl}
                            error={
                              errors.marketingResUrl && touched.marketingResUrl
                            }
                          />
                          <ErrorMessage name="marketingResUrl">
                            {(msg) => (
                              <p className="error-text text-xs">{msg}</p>
                            )}
                          </ErrorMessage>
                        </div>
                        <Button
                          label="Next"
                          className="btn-primary py-5 px-4 w-64 "
                          loading={loading}
                          type="submit"
                        />
                      </div>
                  
                  </form>
                )}
              </Formik>
            </section>
          ) : (
            <AddInstruction
              loading={loading}
              setAddInstruction={setAddInstruction}
              onContinue={handleContinue} // Add this prop to handle the continue button
            />
          )}
        </Modal>
      
    </section>
  );
};

export default MyProductsTable;

export async function getStaticProps() {
  const initialProductData = await getMyProducts();
  return { props: { initialProductData } };
}

// const MyProductsTable = ({ initialProductData }) => {
//   const [viewStats, setViewStats] = useState(false);
//   const [editProduct, setEditProduct] = useState(false);
//   const [openPublishProductModal, setOpenPublishProductModal] = useState(false);
//   const [productInfoModal, setProductInfoModal] = useState(false);
//   const [productToken, setProductToken] = useState("");
//   const [unPublishLoading, setUnpublishLoading] = useState(false);
//   const [preview, setPreview] = useState(null);
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const [cookie, setCookies] = useCookies();
//   const [clickCount, setClickCount] = useState(0);
//   const queryCache = new QueryCache();
//   const [pageSize, setPageSize] = useState(10);
//   const [pageNumber, setPageNumber] = useState(1);
//   const [searchText, setSearchText] = useState();
//   const [activeDropDown, setActiveDropDown] = useState(false);
//   const [buttonText, setButtonText] = useState("Download CSV");
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [addInstruction, setAddInstruction] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [productCategory, setProductCategory] = useState('');
//   const [productType, setProductType] = useState('');
//   const [approvalMethod, setApprovalMethod] = useState('');
//   const categoryData = []; // Add your category data here
//   const productTypeData = []; // Add your product type data here
//   const approveAffiliateBy = []; // Add your approval methods here

//   const handleClick = () => {
//     setButtonText("Coming Soon");
//   };

//   const [selectedDateRange, setSelectedDateRange] = useState({
//     start: null,
//     end: null,
//   });
//   const [filterStatus, setFilterStatus] = useState("all"); // State for filtering by payment status

//   // const {
//   //   data: product,
//   //   isLoadingPPP,
//   //   isError,
//   // } = useQuery('my-products', getMyProducts, {
//   //   initialData: initialProductData,
//   //   staleTime: 1000,
//   // });

//   const {
//     data: products,
//     isLoading,
//     refetch,
//   } = useQuery(
//     ["my-products", pageNumber.pageSize, selectedDateRange, filterStatus],
//     () => {
//       const data = {
//         authToken: cookie?.authToken,
//         pageNumber,
//         pageSize,
//         searchText: searchText,
//         startDate: selectedDateRange.start,
//         endDate: selectedDateRange.end,
//         dateRange: selectedDateRange,
//         status: filterStatus !== "all" ? filterStatus : undefined,
//       };
//       return getMyProducts(data);
//     },
//     {
//       initialData: initialProductData,
//       staleTime: 1000,
//     }
//   );
//   const handleDateRangeChange = (dateRange) => {
//     setSelectedDateRange(dateRange);
//     setPageNumber(1);
//     refetch();
//   };

//   const clearInput = () => {
//     setSearchText("");
//     refetch();
//   };
//   const handleFilterByStatus = (status) => {
//     setFilterStatus(status);
//     setPageNumber(1); // Reset page number when changing filter
//     refetch(); // Explicitly refetch when status changes
//   };
//   // Initialize Router

//   const dataTable = React.useMemo(() => {
//     return products?.data?.data;
//   }, [products]);

//   // Unpublish Product
//   const handleUnPublish = React.useCallback(
//     async (token) => {
//       setUnpublishLoading(true);
//       const data = {
//         productToken: Number(token),
//       };
//       try {
//         const res = await unPublishProduct(data);
//         toast.success("Product Unpublished Successfully");
//         setUnpublishLoading(false);
//         refetch();
//         queryCache.clear("my-products");
//       } catch (error) {
//         setUnpublishLoading(false);
//       }
//     },
//     [queryCache]
//   );

//   const handleResubmit = React.useCallback(async (data) => {
//     setUnpublishLoading(true);
//     const formData = {
//       productToken: Number(data),
//     };
//     try {
//       const res = await reSubmit(formData);
//       toast.success(res.data.message);
//       setUnpublishLoading(false);
//     } catch (error) {
//       toast.error("Something went wrong");
//       setUnpublishLoading(false);
//     }
//   }, []);

//   const column = React.useMemo(() => {
//     return [
//       {
//         Header: "Product Name",
//         accessor: "name",
//       },
//       {
//         Header: "Status",
//         accessor: "status",
//         Cell: ({ row }) => {
//           const renderStatusBadge = (data) => {
//             switch (data) {
//               case "Submitted":
//                 return "info";
//               case "Integrated":
//                 return "info";
//               case "Unpublished":
//                 return "warn";
//               case "Approved":
//                 return "default";
//               case "Published":
//                 return "success";
//               case "Rejected":
//                 return "danger";
//               default:
//                 return "default";
//             }
//           };
//           return (
//             <Badge
//               text={row.values.status}
//               status={renderStatusBadge(row.values.status)}
//             />
//           );
//         },
//       },
//       {
//         Header: "Price",
//         accessor: "price",
//         Cell: ({ row }) => {
//           return `$${row.original.price.toLocaleString()}`;
//         },
//       },
//       {
//         Header: "Commission",
//         accessor: "commission",
//         Cell: ({ row }) => {
//           return `${row.original.commission}%`;
//         },
//       },
//       {
//         Header: "",
//         accessor: "active",
//         Cell: ({ row }) => {
//           const renderStatus = (data) => {
//             switch (data) {
//               case "Approved":
//               case "Submitted":
//                 return "Publish";
//               case "Published":
//                 return "Unpublish";
//               case "Rejected":
//                 return "Appeal";
//               default:
//                 return "Publish";
//             }
//           };
//           return (
//             <div className="flex items-center justify-between">
//               <div></div>
//               <div className="flex items-center">
//                 {row.values.status === "Rejected" ? (
//                   <Link href="#">
//                     <a
//                       href="mailto:admin@stakecut.com"
//                       rel="noreferrer"
//                       target="_blank"
//                     >
//                       <Button
//                         className={`${
//                           row.values.status === "Approved" ||
//                           row.values.status === "Published" ||
//                           row.values.status === "Unpublished"
//                             ? "btn-primary"
//                             : row.values.status === "Rejected"
//                             ? "bg-secondary text-white"
//                             : "bg-neutral-light-40 text-white"
//                         } px-4 py-2 w-[8rem]`}
//                         label={renderStatus(row.values.status)}
//                         loading={unPublishLoading}
//                       />
//                     </a>
//                   </Link>
//                 ) : (
//                   <Button
//                     className={`${
//                       row.values.status === "Approved" ||
//                       row.values.status === "Published" ||
//                       row.values.status === "Unpublished"
//                         ? "btn-primary"
//                         : row.values.status === "Rejected"
//                         ? "bg-secondary text-white"
//                         : "bg-neutral-light-40 text-white"
//                     } px-4 py-2 w-[8rem]`}
//                     label={renderStatus(row.values.status)}
//                     loading={unPublishLoading}
//                     onClick={() => {
//                       if (row.values.status === "Approved") {
//                         setOpenPublishProductModal(true);
//                         setProductToken(row.original.productToken);
//                       } else if (row.values.status === "Published") {
//                         setUnpublishLoading(true);
//                         setTimeout(
//                           () => handleUnPublish(row.original.productToken),
//                           2000
//                         );
//                       } else if (row.values.status === "Unpublished") {
//                         handleResubmit(row.original.productToken);
//                       } else {
//                         console.log("Rejected");
//                       }
//                     }}
//                   />
//                 )}

//                 <PopperMenu context={row} />
//               </div>
//             </div>
//           );
//         },
//       },
//     ];
//   }, []);
//   const handleDownloadCSV = () => {
//     const csvData = dataTable.map((row) => ({
//       ProductName: `${row.name}`,

//       Amount: row.price,
//       Commission: `${row.commission}%`,
//       // Date: getDateTime(row.createdAt),
//       AmountEarned: row.commission,
//       Status: row.paymentStatus,
//     }));

//     const fields = [
//       "ProductName",

//       "Amount",
//       "Commission",
//       "Date",
//       "AmountEarned",
//       "Status",
//     ];
//     const json2csvParser = new Parser({ fields });
//     const csv = json2csvParser.parse(csvData);

//     const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
//     const link = document.createElement("a");
//     const url = URL.createObjectURL(blob);
//     link.setAttribute("href", url);
//     link.setAttribute("download", "Recent_Sales.csv");
//     link.style.visibility = "hidden";
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };
//   // Popper Menu
//   const PopperMenu = ({ context }) => {
//     const [isOpen, setIsOpen] = useState(false);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//     const data = [
//       {
//         item: "View Product Info",
//         url: ``,
//         icon: stat,
//       },
//       {
//         item: "View Stats",
//         url: `/my-product?productToken=${context.original.productToken}`,
//         icon: stat,
//       },
//       { item: "Edit Product Details", url: `#`, icon: pen },
//       {
//         item: "Settings",
//         url: `/dashboard/publish-products/generate-button/${context.original.productToken}`,
//         icon: settings,
//       },
//     ];

//     // eslint-disable-next-line react-hooks/exhaustive-deps
//     const data2 = [
//       {
//         item: "View Product Info",
//         url: ``,
//         icon: stat,
//       },
//       {
//         item: "View Stats",
//         url: `/my-product?productToken=${context.original.productToken}`,
//         icon: stat,
//       },

//       {
//         item: "Settings",
//         url: `/dashboard/publish-products/generate-button/${context.original.productToken}`,
//         icon: settings,
//       },
//     ];

//     const dataList = useMemo(
//       () => (context.values.status === "Approved" ? data : data2),
//       [context.values.status, data, data2]
//     );

//     return (
//       <div
//         className="flex items-center justify-between"
//         // onMouseLeave={() => setIsOpen(false)}
//       >
//         {isOpen && (
//           <div>
//             <RenderPopUp
//               data={data}
//               productToken={context.original.productToken}
//             />
//             <div
//               className="h-full w-full fixed z-40 top-0 left-0"
//               onClick={() => setIsOpen(false)}
//             ></div>
//           </div>
//         )}
//         <div className="flex items-center">
//           <button onClick={() => setIsOpen(true)}>
//             <Ellipsis />
//           </button>
//         </div>
//       </div>
//     );
//   };

//   // Render Popup menu
//   const RenderPopUp = ({ data, productToken }) => {
//     return (
//       <ul className="p-2 h-auto shadow ml-[-120px] absolute bg-primary z-50">
//         {data.length > 0 &&
//           data.map((list, idx) => {
//             return (
//               <li
//                 className={`text-xs py-3 text-neutral-light-50 hover:text-white hover:bg-primary-p300 px-2 transition-all duration-200 ease-in-out `}
//                 onClick={() => {
//                   if (idx === 1) {
//                     setViewStats(true);
//                     setEditProduct(false);
//                     setProductInfoModal(false);
//                   } else if (idx === 2) {
//                     setViewStats(false);
//                     setEditProduct(true);
//                     setProductInfoModal(false);
//                   } else if (idx === 0) {
//                     setProductInfoModal(true);
//                     setViewStats(false);
//                     setEditProduct(false);
//                   } else {
//                     window.location.href = list.url;
//                   }
//                   setProductToken(productToken);
//                   setClickCount((prev) => prev++);
//                 }}
//                 key={idx}
//               >
//                 <Link href={data.url || "#"} passHref>
//                   <div className="flex items-center">
//                     <div className="flex items-center justify-center">
//                       <Image src={list.icon} alt="icon" />
//                     </div>
//                     <div className="ml-3">{list.item}</div>
//                   </div>
//                 </Link>
//               </li>
//             );
//           })}
//       </ul>
//     );
//   };
//   return (
//     <>
//       {isLoading ? (
//         <div className="flex items-center justify-center ">
//           <PageLoader
//             loadingText="Loading Products, Please Wait... 😇 "
//             className="h-96 w-full"
//           />
//         </div>
//       ) : (
//         <div>
//   <div>
//     <div className="flex justify-between items-center my-16">
//       <div className="text-[14px] text-[#828282]">
//         Products{" "}
//         <span className="text-[#58D96B]">({products.length})</span>
//       </div>
//       <div className="flex items-center">
//         <Button
//           className="px-5 py-3 btn-primary w-[174px] h-[42px]"
//           label="Publish Product"
//           onClick={() => setIsModalOpen(true)}
//         />
//       </div>
//     </div>
//     <hr />
//   </div>
//   <>
//     {products.length === 0 ? (
//       <div className="text-center my-16">
//         <p className="text-[18px] text-[#828282]">Hey, you don’t have any products available.</p>
//       </div>
//     ) : (
//       <>
//         {openPublishProductModal && (
//           <PublishProductModal
//             setOpenPublishProductModal={setOpenPublishProductModal}
//             productToken={productToken}
//           />
//         )}
//         {viewStats && (
//           <ViewStatsModal
//             setViewStats={setViewStats}
//             productToken={productToken}
//           />
//         )}
//         {editProduct && (
//           <EditProductModal
//             setEditProduct={setEditProduct}
//             productToken={productToken}
//           />
//         )}
//         {productInfoModal && (
//           <ProductInfo
//             setProductInfoModal={setProductInfoModal}
//             productToken={productToken}
//           />
//         )}
//         <Table
//           columns={column}
//           data={dataTable}
//           productToken={productToken}
//           pageSize={pageSize}
//           currentPage={pageNumber}
//           setPageNumber={setPageNumber}
//           setPageSize={setPageSize}
//           refetch={refetch}
//           searchText={searchText}
//           setSearchText={setSearchText}
//           totalPage
//         />
//       </>
//     )}
//   </>
// </div>

//       )}
//       <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
//       <Formik
//       // Initialise Initial Form Values
//       initialValues={{
//         price: '',
//         productName: '',
//         image: preview,
//         productDescription: '',
//         commission: '',
//         marketingResUrl: '',
//         salesPageUrl: '',
//         thankYouPageUrl: '',
//       }}
//       // Function for Error message Display
//       validationSchema={productPublishFormValidationSchema}
//       // Submit Function
//       onSubmit={async data => {
//         handlePublishProduct(data);
//       }}
//     >
//       {({
//         values,
//         handleChange,
//         handleSubmit,
//         errors,
//         touched,
//         setFieldValue,
//       }) => (
//         <form
//           onSubmit={e => {
//             e.preventDefault();
//             handleSubmit();
//           }}
//           encType="multipart/form-data"
//         >
//           {addInstruction && (
//             <AddInstruction
//               loading={loading}
//               setAddInstruction={setAddInstruction}
//             />
//           )}

//           <section className="grid grid-cols-3 px-6 gap-24">
//             <div className="lg:col-span-2 col-span-3 order-2 lg:order-1">
//               <div>
//                 <label htmlFor="" className="text-base mb-2">
//                   Product Name
//                 </label>
//                 <Input
//                   placeholder="Enter Product Name"
//                   onChange={handleChange}
//                   type="text"
//                   name="productName"
//                   value={values.productName}
//                   error={errors.productName && touched.productName}
//                 />
//                 <ErrorMessage name="productName">
//                   {msg => <p className="error-text text-xs">{msg}</p>}
//                 </ErrorMessage>
//               </div>
//               <div className="mt-4">
//                 <TextArea
//                   label="Description"
//                   placeholder="Enter Product Description"
//                   onChange={handleChange}
//                   textAreaName="productDescription"
//                   value={values.productDescription}
//                   error={
//                     errors.productDescription && touched.productDescription
//                   }
//                 />
//                 <ErrorMessage name="productDescription">
//                   {msg => <p className="error-text text-xs">{msg}</p>}
//                 </ErrorMessage>
//               </div>
//               <div className="grid grid-cols-2 gap-3 lg:gap-6 mt-6">
//                 <div>
//                   <label htmlFor="" className="text-sm lg:text-base  mb-2">
//                     Product Category
//                   </label>
//                   <DropDown
//                     options={categoryData}
//                     value={productCategory}
//                     selected={productCategory}
//                     setSelected={setProductCategory}
//                     setValue={setProductCategory}
//                   />
//                   <ErrorMessage name="productCategory">
//                     {msg => <p className="error-text text-xs">{msg}</p>}
//                   </ErrorMessage>
//                 </div>
//                 <div>
//                   <label htmlFor="" className="text-sm lg:text-base mb-2">
//                     Product Type
//                   </label>
//                   <DropDown
//                     options={productTypeData}
//                     value={productType}
//                     setValue={setProductType}
//                     selected={productType}
//                     setSelected={setProductType}
//                   />
//                 </div>
//               </div>
//               <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 lg:gap-6 mt-6">
//                 <div>
//                   <label htmlFor="" className="text-sm lg:text-base mb-2">
//                     Currency
//                   </label>
//                   <Input
//                     placeholder="USD"
//                     onChange={handleChange}
//                     type="text"
//                     name="Currency"
//                     value="USD"
//                     disabled={true}
//                   />
//                 </div>
//                 <div className="col-span-2 lg:col-span-1">
//                   <label htmlFor="" className="text-sm lg:text-base mb-2">
//                     Product Price
//                   </label>
//                   <Input
//                     placeholder="Enter Product Price"
//                     onChange={handleChange}
//                     type="number"
//                     name="price"
//                     value={values.price}
//                     error={errors.price && touched.price}
//                   />
//                   <ErrorMessage name="price">
//                     {msg => <p className="error-text text-xs">{msg}</p>}
//                   </ErrorMessage>
//                 </div>
//               </div>
//               <div className="grid grid-cols-2  gap-3 lg:gap-6  mt-6">
//                 <div className="col-span-2 lg:col-span-1">
//                   <label htmlFor="" className="text-sm lg:text-base mb-2">
//                     Commission Percentage
//                   </label>
//                   <Input
//                     type="number"
//                     placeholder="Enter Commission Percentage"
//                     onChange={handleChange}
//                     name="commission"
//                     value={values.commission}
//                     error={errors.commission && touched.commission}
//                   />
//                 </div>
//                 <div className="col-span-2 lg:col-span-1">
//                   <label htmlFor="" className="text-sm lg:text-base mb-2">
//                     How to approve Affiliates
//                   </label>
//                   <DropDown
//                     options={approveAffiliateBy}
//                     selected={approvalMethod}
//                     setSelected={setApprovalMethod}
//                     value={approvalMethod}
//                     setValue={setApprovalMethod}
//                   />
//                 </div>
//               </div>
//               <div className="mt-6">
//                 <label htmlFor="" className="text-sm lg:text-base mb-2">
//                   URL to Product Sales Page
//                 </label>
//                 <Input
//                   placeholder="Enter URL for Product Sales Page"
//                   onChange={handleChange}
//                   type="text"
//                   name="salesPageUrl"
//                   value={values.salesPageUrl}
//                   error={errors.salesPageUrl && touched.salesPageUrl}
//                 />
//                 <ErrorMessage name="salesPageUrl">
//                   {msg => <p className="error-text text-xs">{msg}</p>}
//                 </ErrorMessage>
//               </div>
//               <div className="mt-6">
//                 <label htmlFor="" className="text-sm lg:text-base mb-2">
//                   URL to Product Download or Thank you page
//                 </label>
//                 <Input
//                   placeholder="Enter URL for Product Download or Thank you page"
//                   onChange={handleChange}
//                   type="text"
//                   name="thankYouPageUrl"
//                   value={values.thankYouPageUrl}
//                   error={errors.thankYouPageUrl && touched.thankYouPageUrl}
//                 />
//                 <ErrorMessage name="thankYouPageUrl">
//                   {msg => <p className="error-text text-xs">{msg}</p>}
//                 </ErrorMessage>
//               </div>
//               <div className="mt-6 mb-9">
//                 <label htmlFor="" className="text-sm lg:text-base mb-2">
//                   URL to JV Page or Marketing Resources
//                 </label>
//                 <Input
//                   placeholder="Enter the URL of your marketing resources"
//                   onChange={handleChange}
//                   type="text"
//                   name="marketingResUrl"
//                   value={values.marketingResUrl}
//                   error={errors.marketingResUrl && touched.marketingResUrl}
//                 />
//                 <ErrorMessage name="marketingResUrl">
//                   {msg => <p className="error-text text-xs">{msg}</p>}
//                 </ErrorMessage>
//               </div>
//               <Button
//                 label="Next"
//                 className="btn-primary py-5 px-4 w-64 "
//                 loading={loading}
//                 type="submit"
//               />
//             </div>
//             <div className="col-span-3 lg:col-span-1 order-1 lg:order-2  lg:items-start mt-3 lg:mt-auto h-full">
//               <div className="flex items-center justify-center">
//                 <div
//                   className={`h-44 rounded-full relative w-44 bg-gradient-to-t from-slate-700 to-slate-400 overflow-hidden ${
//                     errors.image && touched.image
//                       ? 'border-2 border-red-400'
//                       : null
//                   }`}
//                 >
//                   <Image
//                     src={preview ? URL.createObjectURL(preview) : cameraImg}
//                     layout="fill"
//                     alt="upload"
//                     objectFit="cover"
//                   />
//                   <div className="absolute">
//                     <input
//                       type="file"
//                       className="h-44 w-44 opacity-0"
//                       name="image"
//                       accept="image/*"
//                       onChange={e => {
//                         setPreview(e.target.files[0]);
//                         setFieldValue('image', e.target.files[0]);
//                       }}
//                     />
//                   </div>
//                 </div>
//               </div>
//               <div className="flex items-center justify-center">
//                 <ErrorMessage name="image">
//                   {msg => (
//                     <p className="error-text text-center text-xs">{msg}</p>
//                   )}
//                 </ErrorMessage>
//               </div>
//             </div>
//           </section>
//         </form>
//       )}
//     </Formik>
//       </Modal>
//     </>
//   );
// };

// export default MyProductsTable;

// export async function getStaticProps() {
//   const initialProductData = await getMyProducts();
//   return { props: { initialProductData } };
// }
